import React, {useContext} from 'react';
import {Col, Container, Row} from "reactstrap";
import Header from "../../layout/Header";
import {BookingCardFactory} from "./BookingCardFactory";
import {TProductContainerProps} from "../../../lib/utils/types";
import {GlobalState} from "../../../lib/api/globalState"
import Error from "../../Error";
import {t} from "i18next";

const ProductContainer = ({
        headerLabel = 'productContainer.headerLabel',
        children,
        productType,
        bookingCardProps,
    }: TProductContainerProps): JSX.Element => {
    // @ts-ignore
    const [state] = useContext(GlobalState);
    const isBackendError = state?.isBackendError

    const dynamicStyles = {
        maxWidth: isBackendError && "100%"
    }

    return (
    <Container className={'pl-0 pr-0'} style={dynamicStyles}>
        <Row className={'min-vh-100 no-gutters'}>
            <Col xs={12} lg={6} className={'form-col'}>
                {!isBackendError ?
                <>
                    <Header label={headerLabel}/>
                    {children}
                </>
                : <Error customText={t('api.errors.backendError')}/>
                }
            </Col>
            <Col xs={6} className={'offset-sm-6 card-col min-vh-100 fixed-top d-none d-lg-block'}>
                {!isBackendError && bookingCardProps ? BookingCardFactory(productType, bookingCardProps) : <></>}
            </Col>
        </Row>
    </Container>
)};

export default ProductContainer;